<script context="module">

  import SubscriptionDetails from './SubscriptionDetails.svelte';
  import { External as Ext } from '../../external';

  export const showSubscriptionDetails = (subscription, {
    onCanceled = () => {
    }, onActivated = () => {
    }, onUpdated = () => {
    }
  }) => {
    Ext.Tools.showWindow({
      isModal: false,
      withDarkBackground: true,
      noTitle: true,
      width: 600,
      noNav: true,
      forceAtRight: true,
      action: {
        onShow: (popup) => {
          popup.bindComponent(
            new SubscriptionDetails({
              target: popup.getContentArea(),
              props: {
                subscription: subscription,
                onSubscriptionCanceled: () => {
                  popup?.close();
                  onCanceled(subscription);
                },
                onSubscriptionActivated: () => {
                  popup?.close();
                  onActivated(subscription);
                },
                onSubscriptionUpdated: (updatedSubscription) => {
                  popup?.close();
                  onUpdated(updatedSubscription);
                }
              }
            })
          );
        }
      }
    });
  };
</script>
<script>
  import { External, M } from '../../external';
  import { makeWebsiteRequest, splitDateStringToDateTimeParts } from '../../Common/tools';
  import UpdateSubscription from './UpdateSubscription.svelte';

  export let subscription;
  export let onSubscriptionCanceled;
  export let onSubscriptionActivated;
  export let onSubscriptionUpdated;

  const cancelSubscription = () => {
    External.Tools.prompt(M.CANCEL_SUBSCRIPTION_TITLE, M.CANCEL_CONTACT_SUBSCRIPTION_MSG, async () => {
      await makeWebsiteRequest({
        action: 'cancelStoreSubscription',
        method: 'post',
        data: {
          id: subscription.id,
          memberId: subscription.memberId
        }
      })
      .then(onSubscriptionCanceled);
    });
  };

  let activateSubscription = async () => {
    External.Tools.prompt('', M.ACTIVATE_SUBSCRIPTION_MSG, async () => {
      await makeWebsiteRequest({
        action: 'activateStoreSubscription',
        method: 'post',
        data: {
          id: subscription.id,
          memberId: subscription.memberId
        }
      })
      .then(onSubscriptionActivated);
    });
  };


  let editSubscription = async () => {
    External.Tools.showWindow({
      title: M.EDIT_SUBSCRIPTION,
      width: 500,
      action: {
        onShow: (popup) => {
          popup.bindComponent(new UpdateSubscription({
            target: popup.getContentArea(),
            props: {
              subscription: subscription
            }
          }));
        }
      },
      buttons: [
        External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, async (popup) => {
          const {
            selectedCyclesOption,
            selectedPeriodOption,
            selectedPeriodUnitOption,
            selectedPrice,
            selectedNextBillingDate
          } = popup.component().get();
          const response = await makeWebsiteRequest({
            action: 'updateStoreSubscription',
            method: 'post',
            data: {
              id: subscription.id,
              subscription: JSON.stringify({
                cycles: selectedCyclesOption,
                price: selectedPrice,
                nextBillingDate: selectedNextBillingDate,
                period: selectedPeriodOption,
                periodUnit: selectedPeriodUnitOption
              })
            }
          });

          if (!response.data) {
            return;
          }
          const updatedSubscription = response.data.subscription;

          const nextBillingDate = splitDateStringToDateTimeParts(updatedSubscription.nextBillingDate);
          let paymentsLbl = '';
          if (updatedSubscription.cycles) {
            paymentsLbl = External.format(M.PAYMENT_NO, 'curr', updatedSubscription.charges, 'all', updatedSubscription.cycles);
          }
          let cycleLbl;
          if (updatedSubscription.period === 1) {
            cycleLbl = updatedSubscription.periodUnit === 'MONTHLY' ? M.MONTHLY : M.WEEKLY;
          } else if (updatedSubscription.period === 12 && updatedSubscription.periodUnit === 'MONTHLY') {
            cycleLbl = M.YEARLY;
          } else {
            cycleLbl = updatedSubscription.period + '-' + (updatedSubscription.periodUnit === 'MONTHLY' ? M.MONTHS : M.WEEKS);
          }
          const priceLbl = External.WebPlatform.currToStr(
            updatedSubscription.price,
            External.Website.storeCurrencySymbol,
            External.Website.storeCurrencyPositionAtLeft,
            External.Website.storeCurrency,
            External.Website.storeCountry
          );

          const updatedTableRow = {
            ...updatedSubscription,
            nextChargeDate: nextBillingDate.date,
            nextChargeTime: nextBillingDate.time,
            priceLbl: priceLbl,
            paymentsLbl: paymentsLbl,
            cycleLbl: cycleLbl
          };
          popup.close();
          onSubscriptionUpdated(updatedTableRow);
        }),
        External.Button.MIDDLE_CANCEL
      ]
    });
  };

  const getProductLink = () => {
    return `/me/store/products/${subscription.productId}`;
  };

  const getCustomerLink = () => {
    return `/me/crm/contact/${subscription.contactId}`;
  };
</script>

<div id="test-subscription-management" data-force-right="true" data-width="600" data-title="false">
  <div class="popup-widget-wrapper">
    <h4 class="col20 f-left mt-5 mb-5 t-center h4-bigger">{M.SUBSCRIPTION_MANAGEMENT}</h4>
    <span class="light-gray-text t-center col20 f-left mb-25 padded-text">{M.STATUS}:
      <span class="order-status pending ml-5 inline-block dark-gray-bg" style="cursor: default;">{M[subscription.status]}</span>
    </span>
    {#if subscription.status === 'EXPIRED'}
      <div class="col20 f-left t-center flex justify-center mb-15">
        <a on:click={activateSubscription} class="middle-button blue">{M.REACTIVATE}</a>
      </div>
    {/if}
    <div class="analytics-boxes-wrapper white-bg mb-10">
      <div class="analytics-box half-box">
        <div class="col20 flex space-between align-center mb-10">
          <h4>{M.CYCLE}</h4>
          <a on:click={editSubscription} class="blue-text" data-role="show-tab"
             data-tab="analytics">{M.EDIT}</a>
        </div>
        <h2 class="col20 f-left f-18 gray-text"><b>{subscription.cycleLbl}</b></h2></div>
      <div class="analytics-box half-box">
        <div class="col20 flex space-between align-center mb-10">
          <h4>{M.PRICE}</h4>
          <a on:click={editSubscription} class="blue-text" data-role="show-tab"
             data-tab="analytics">{M.EDIT}</a>
        </div>
        <h2 class="col20 f-left f-18 gray-text">
          <b>{External.Tools.currencyToStrWithSymbol(subscription.price)}</b></h2></div>
    </div>
    <div class="analytics-boxes-wrapper white-bg mb-10">
      <div class="analytics-box half-box ">
        <div class="col20 flex space-between align-center mb-10">
          <h4>{M.LAST_PAYMENT}</h4>
        </div>
        <h2 class="col20 f-left f-18 gray-text"><b>{subscription.lastChargeDate}</b></h2></div>
      <div class="analytics-box half-box">
        <div class="col20 flex space-between align-center mb-10">
          <h4>{M.NEXT_PAYMENT}</h4>
          <a on:click={editSubscription} class="blue-text" data-role="show-tab"
             data-tab="analytics">{M.EDIT}</a>
        </div>
        <h2 class="col20 f-left f-18 gray-text"><b>
          {#if subscription.status === 'EXPIRED'}
            {M.EXPIRED}
          {:else}
            {subscription.nextChargeDate}
          {/if}
        </b></h2>
      </div>
    </div>
    <div class="analytics-boxes-wrapper white-bg mb-10">
      <div class="analytics-box half-box">
        <div class="col20 flex space-between align-center mb-10">
          <h4>{M.REVENUE_GENERATED}</h4>
        </div>
        <h2 class="col20 f-left f-18 gray-text">
          <b>{External.Tools.currencyToStrWithSymbol(subscription.revenueGenerated)}</b></h2></div>
      <div class="analytics-box half-box">
        <div class="col20 flex space-between align-center mb-10">
          <h4>{M.RECURRING_PAYMENTS}</h4>
          <a on:click={editSubscription} class="blue-text" data-role="show-tab"
             data-tab="analytics">{M.EDIT}</a>
        </div>
        <h2 class="col20 f-left f-18 gray-text">
          <b>{subscription.charges} /
            {#if !!subscription.cycles}
              {subscription.cycles}
            {:else}&infin;
            {/if}
          </b>
        </h2></div>
    </div>
    <div class="analytics-boxes-wrapper white-bg mb-10">
      <div class="analytics-box half-box">
        <div class="col20 flex space-between align-center mb-10">
          <h4>{M.PRODUCT}</h4>
          <a class="blue-text close-popup" rel="tab" href="{getProductLink()}">{M.VIEW}</a>
        </div>
        <h2 class="col20 f-left f-18 gray-text"><b>{subscription.productName}</b></h2>
        <!--<span class="col20 f-left mt-5" style="margin-left: 0px; opacity: 0.7;">{subscription.productType}</span>-->
      </div>
      <div class="analytics-box half-box">
        <div class="col20 flex space-between align-center mb-10">
          <h4>{M.START_DATE}</h4>
        </div>
        <h2 class="col20 f-left f-18 gray-text">
          <b>{subscription.createdDate}</b>
        </h2></div>
    </div>
    <div class="flex align-center col20 mb-10">
      <div class="analytics-box col20 less-padding full-box no-shadow">
        <div class="col20 flex space-between align-center mb-10">
          <h4>{M.CUSTOMER}</h4>
          <a class="blue-text close-popup" rel="tab" href="{getCustomerLink()}">{M.VIEW}</a>
        </div>
        <h2 class="col20 f-left f-18 gray-text"><b>{subscription.customerName}</b></h2>
        <h4 class="col20 f-left mt-5">{subscription.customerEmail}</h4>
      </div>
    </div>
    <div class="flex align-center justify-center col20 mb-15 t-center">
      {#if subscription.status === 'ACTIVE'}
        <a on:click={cancelSubscription} class="middle-button gray f-none inline-block">{M.CANCEL_SUBSCRIPTION_TITLE}</a>
      {/if}
    </div>
  </div>
</div>
